// src/views/InformationPublications/CreateInformationPublication.tsx

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

import { useEntity } from '../../context/EntityContext';
import AnimatedBackdrop from '../../components/AnimatedBackdrop';
import SingleFileUploader from './SingleFileUploader';
import { createInformationPublication } from '../../services/informationPublicationsService';

const CreateInformationPublication: React.FC = () => {
  const navigate = useNavigate();
  const { selectedEntity } = useEntity();

  const [file, setFile] = useState<File | null>(null);

  const [loading, setLoading] = useState(false);
  const [showProcessing, setShowProcessing] = useState(false);

  const handleSubmit = async () => {
    if (!selectedEntity) {
      swal('Atenção', 'Selecione uma entidade para prosseguir.', 'info');
      return;
    }
    if (!file) {
      swal('Atenção', 'Nenhum arquivo PDF selecionado.', 'info');
      return;
    }

    setLoading(true);
    setShowProcessing(true);

    try {
      const payload = {
        entity_id: selectedEntity,
        file
      };
      const result = await createInformationPublication(payload);
      
      // Atraso para dar tempo da animação de loading ser percebida
      setTimeout(() => {
        // Redireciona para a página de DETALHES, passando um estado para ativar a animação
        navigate(`/informacoes/${result.id}`, {
          state: {
            showAnimation: true
          },
        });
      }, 800);
    } catch (error) {
      console.error('Erro ao criar informação:', error);
      swal('Erro', 'Falha ao criar informação. Tente novamente.', 'error');
      // Garante que o loading para em caso de erro
      setLoading(false);
      setShowProcessing(false);
    }
    // Não seta loading para false aqui para manter o backdrop durante a navegação
  };

  if (!selectedEntity) {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" color="error">
          Selecione uma entidade antes de prosseguir.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {showProcessing && (
        <AnimatedBackdrop
          title="Processando arquivo"
          subtitle="Aguarde enquanto o PDF é analisado..."
        />
      )}

      <Box
        sx={{
          mt: 4,
          opacity: showProcessing ? 0.3 : 1,
          pointerEvents: showProcessing ? 'none' : 'auto'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h5">Criar Nova Informação</Typography>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Voltar
          </Button>
        </Box>

        <Typography variant="body2" sx={{ mb: 1 }}>
          Arquivo (somente 1 PDF):
        </Typography>

        <SingleFileUploader
          file={file}
          setFile={setFile}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
          sx={{ mt: 3 }}
        >
          {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Enviar'}
        </Button>
      </Box>
    </>
  );
};

export default CreateInformationPublication;